import { ReactNode } from 'react'
import { Control, Controller, FieldValues, UseFormRegister } from 'react-hook-form'

interface RadioOption {
    label: string
    value: string
}

interface GenericRadioProps {
    title: string
    name: string
    options: RadioOption[]
    register: UseFormRegister<FieldValues>
    control: Control<any, any>
    defaultValue?: string
    errors?: any
    inputClassNames?: string
    styleContainer?: string
    readOnly?: boolean
    disabled?: boolean
    required?: boolean
    children?: ReactNode
}

export const GenericRadioGroup = ({
    title,
    name,
    options,
    register,
    control,
    defaultValue,
    errors,
    inputClassNames,
    styleContainer,
    readOnly,
    disabled,
    required,
    children
}: GenericRadioProps) => {
    return (
        <Controller
            data-testid="test-genericRadio"
            defaultValue={defaultValue ?? ''}
            control={control}
            rules={{ required: required }}
            name={name}
            render={({ field: { onChange, onBlur, value, ref, name: fieldName } }) => (
                <fieldset
                    className={['relative pointer-events-auto', styleContainer].filter(Boolean).join(' ')}
                >
                    <legend className="flex items-center gap-2 font-semibold text-xs text-darkGray">
                        {title}
                        {children}
                    </legend>

                    {options.map((opt, idx) => (
                        <div key={opt.value} className="flex items-center gap-2">
                            <input
                                ref={idx === 0 ? ref : undefined}
                                type="radio"
                                id={`${name}-${opt.value}`}
                                name={fieldName}
                                value={opt.value}
                                checked={value === opt.value}
                                onChange={() => onChange(opt.value)}
                                onBlur={onBlur}
                                className={`text-yellow ${inputClassNames}`}
                                readOnly={!!readOnly}
                                disabled={disabled}
                            />

                            <label htmlFor={`${name}-${opt.value}`} className="text-sm">
                                {opt.label}
                            </label>
                        </div>
                    ))}

                    {readOnly && (
                        <input type="hidden" value={defaultValue ?? value} {...register(name)} />
                    )}

                    {errors && (
                        <span className="text-errorText text-xs font-normal absolute">
                            Preenchimento obrigatório
                        </span>
                    )}
                </fieldset>
            )}
        />
    )
}
